// Where a lead came from, as the team reads it; the API keeps the codes.
export const LEAD_SOURCE_LABELS = {
  homepage_form: "Formular site",
  main_form: "Formular site",
  popup: "Popup broșură",
  brochure_request: "Cerere broșură",
  webinar: "Webinar",
  inscriere_neplatita: "Înscriere neplătită",
  manual: "Manual",
  admin: "Adăugat din admin",
};

export const leadSourceLabel = (source) => LEAD_SOURCE_LABELS[source] || source || "—";
